import { Component, type ErrorInfo, type ReactNode } from 'react'
import { uiMessages } from '../i18n/ui'

type Props = { children: ReactNode }
type State = { failed: boolean }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { failed: false }

  static getDerivedStateFromError(): State {
    return { failed: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Application boundary caught an error', error, info)
  }

  render() {
    if (!this.state.failed) return this.props.children

    return (
      <main className="error-boundary">
        <div className="page-frame error-boundary__inner">
          <h1>{uiMessages['error.title'].it}</h1>
          <p>{uiMessages['error.body'].it}</p>
          <button className="button button--primary button--default" onClick={() => window.location.reload()}>
            <span>{uiMessages['error.reload'].it}</span>
          </button>
        </div>
      </main>
    )
  }
}
